/* Endurrad — homepage «a bacheca». File aggiunto: sopravvive agli aggiornamenti del tema.
   Caricato da sections/erd-bacheca.liquid.
   1. Schede dei best seller (tutte già stampate nella pagina: qui si cambia solo quella visibile).
   2. Riquadro «Per la tua moto»: se il cliente ha scelto la moto (localStorage «erd_moto_sel»,
      lo stesso del selettore), mostra 4 prodotti della collezione di quella moto. */
(function () {
  var root = document.querySelector('[data-erd-bach]');
  if (!root) return;

  /* 1. Schede */
  var tabs = Array.prototype.slice.call(root.querySelectorAll('.erd-bach__tab'));
  function apri(t, fuoco) {
    tabs.forEach(function (x) {
      var on = x === t;
      x.setAttribute('aria-selected', on ? 'true' : 'false');
      x.tabIndex = on ? 0 : -1;
      var p = document.getElementById(x.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
    if (fuoco) t.focus();
  }
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { apri(t, false); });
    t.addEventListener('keydown', function (e) {
      var k = e.key, j = -1;
      if (k === 'ArrowRight') j = (i + 1) % tabs.length;
      else if (k === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
      else if (k === 'Home') j = 0;
      else if (k === 'End') j = tabs.length - 1;
      if (j > -1) { e.preventDefault(); apri(tabs[j], true); }
    });
  });

  /* 1b. Carosello dei riquadri: frecce avanti e indietro di una «pagina» */
  var car = root.querySelector('.erd-bach__car.is-car');
  if (car) {
    var sc = car.querySelector('[data-erd-bach-scroll]');
    var prev = car.querySelector('[data-erd-bach-prev]');
    var next = car.querySelector('[data-erd-bach-next]');
    var stato = function () {
      var max = sc.scrollWidth - sc.clientWidth - 2;
      if (prev) prev.disabled = sc.scrollLeft <= 2;
      if (next) next.disabled = sc.scrollLeft >= max;
    };
    var vai = function (dir) {
      var t = sc.querySelector('.erd-bach__tile');
      var passo = t ? t.getBoundingClientRect().width + 16 : sc.clientWidth;
      var n = Math.max(1, Math.round(sc.clientWidth / passo));
      sc.scrollBy({ left: dir * passo * n, behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { vai(-1); });
    if (next) next.addEventListener('click', function () { vai(1); });
    sc.addEventListener('scroll', function () { window.requestAnimationFrame(stato); }, { passive: true });
    window.addEventListener('resize', stato);
    stato();
  }

  /* 1c. Foto dei riquadri oltre il quarto: si caricano quando il carosello si avvicina */
  var attese = Array.prototype.slice.call(root.querySelectorAll('img[data-erd-src]'));
  if (attese.length) {
    var carica = function (img) {
      if (!img.hasAttribute('data-erd-src')) return;
      if (img.getAttribute('data-erd-srcset')) img.setAttribute('srcset', img.getAttribute('data-erd-srcset'));
      img.setAttribute('src', img.getAttribute('data-erd-src'));
      img.removeAttribute('data-erd-srcset');
      img.removeAttribute('data-erd-src');
    };
    var scr = root.querySelector('[data-erd-bach-scroll]');
    if ('IntersectionObserver' in window && scr) {
      var io = new IntersectionObserver(function (voci) {
        voci.forEach(function (v) {
          if (!v.isIntersecting) return;
          Array.prototype.forEach.call(v.target.querySelectorAll('img[data-erd-src]'), carica);
          io.unobserve(v.target);
        });
      }, { root: scr, rootMargin: '0px 24px 0px 0px' });
      var riq = [];
      attese.forEach(function (img) { var t = img.closest('.erd-bach__tile'); if (t && riq.indexOf(t) < 0) riq.push(t); });
      riq.forEach(function (t) { io.observe(t); });
      /* Precarica appena il cliente mostra interesse: mouse sulla freccia o dito sul carosello */
      var tutte = function () { attese.forEach(carica); };
      var nx = root.querySelector('[data-erd-bach-next]');
      if (nx) { nx.addEventListener('pointerenter', tutte, { once: true }); nx.addEventListener('focus', tutte, { once: true }); }
      scr.addEventListener('touchstart', tutte, { once: true, passive: true });
    } else {
      attese.forEach(carica);
    }
  }

  /* 1d. Regola fissa: lo stesso prodotto non compare mai due volte in homepage.
     Hanno la precedenza i promo fissi della homepage (video, CarPlay: [data-erd-fisso]),
     poi i riquadri in ordine; al posto dei doppioni salgono i prodotti di riserva. */
  function unici() {
    var visti = {};
    Array.prototype.forEach.call(document.querySelectorAll('[data-erd-fisso]'), function (a) { visti[a.getAttribute('data-erd-fisso')] = 1; });
    Array.prototype.forEach.call(root.querySelectorAll('.erd-bach__tile'), function (t) {
      var n = 0;
      /* data-erd-h = ogni prodotto del riquadro; data-handle solo su quelli visibili (lo legge la homepage) */
      Array.prototype.forEach.call(t.querySelectorAll('[data-erd-bach-q] > [data-erd-h], [data-erd-bach-q] > [data-handle]'), function (a) {
        var h = a.getAttribute('data-erd-h') || a.getAttribute('data-handle'), ok = !visti[h] && n < 4;
        a.hidden = !ok;
        if (ok) a.setAttribute('data-handle', h); else a.removeAttribute('data-handle');
        if (ok) { n++; visti[h] = 1; }
      });
    });
    try { document.dispatchEvent(new CustomEvent('erd:bach-moto')); } catch (e) {}
  }
  unici();

  /* 2. Riquadro della moto */
  var tile = root.querySelector('[data-erd-bach-moto]');
  if (!tile) return;
  var m = null;
  try { m = JSON.parse(window.localStorage.getItem('erd_moto_sel') || 'null'); } catch (e) {}
  if (!m || !m.base || !m.url || m.url.indexOf('/collections/') !== 0) return;
  var url = m.url.split('?')[0].replace(/\/$/, '');
  var euro = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* Regola fissa: niente prodotti già presenti negli altri riquadri */
  var altri = {};
  Array.prototype.forEach.call(root.querySelectorAll('.erd-bach__tile:not([data-erd-bach-moto]) [data-handle]'), function (a) { altri[a.getAttribute('data-handle')] = 1; });
  Array.prototype.forEach.call(document.querySelectorAll('[data-erd-fisso]'), function (a) { altri[a.getAttribute('data-erd-fisso')] = 1; });
  fetch(url + '/products.json?limit=16', { credentials: 'same-origin' })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (d) {
      var ps = ((d && d.products) || []).filter(function (p) { return !altri[p.handle]; });
      if (!ps.length) return;
      var tipo = tile.getAttribute('data-etichetta');
      var fisso = tile.getAttribute('data-testo') || '';
      var html = ps.slice(0, 4).map(function (p) {
        var v = (p.variants || [])[0] || {};
        var prezzo = parseFloat(v.price || 0), pieno = parseFloat(v.compare_at_price || 0);
        var pill = euro.format(prezzo);
        if (tipo === 'sconto' && pieno > prezzo) pill = '-' + Math.floor((pieno - prezzo) * 100 / pieno) + '%';
        if (tipo === 'testo') pill = fisso;
        var img = (p.images || [])[0];
        var src = img ? img.src.replace(/(\.[a-z]+)(\?|$)/i, '$1?width=300&') : '';
        return '<a class="erd-bach__qi" href="/products/' + esc(p.handle) + '" data-handle="' + esc(p.handle) + '">' +
          (src ? '<img src="' + esc(src) + '" alt="' + esc(p.title) + '" loading="lazy" width="300" height="300">' : '') +
          '<span class="erd-bach__pill">' + esc(pill) + '</span>' +
          '<span class="erd-bach__sr">' + esc(p.title) + '</span></a>';
      }).join('');
      tile.querySelector('[data-erd-bach-q]').innerHTML = html;
      /* ricalcolo dei doppioni (riquadri e resto della homepage) con i prodotti nuovi */
      unici();
      var a = tile.querySelector('[data-erd-bach-link]');
      var testo = 'Per la tua ' + m.base;
      if (a) { a.textContent = testo; a.setAttribute('href', url); }
      else tile.querySelector('[data-erd-bach-titolo]').textContent = testo;
    })
    .catch(function () {});
})();
